<template>
<Dialog type="products" :show="$bus.productsDialog.show" :title="$bus.transify['LUCKY_GOODS_TITLE']">
  <template v-slot:dialog-content>
    <div class="products-content">
      <div class="products-content-list" ref="contentList">
        <div class="content-list">
          <Item v-for="(item, index) in $bus.productsDialog.data" @click.native.stop="showName(index)" role="li" class="item" type="reward" :key="item.pk" :nums="item.item_num" :imgSrc="item.item_img">
            <template v-slot:mask-name>
              <div class="product-item-name" @click.stop v-show="index === $bus.activeIndex">
                <span class="bebas-font">{{item.item_name}}</span>
              </div>
            </template>
          </Item>
        </div>
      </div>
    </div>
  </template>
</Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'
import Item from '@/components/common/Item.vue'
export default {
  components: {
    Dialog,
    Item
  },
  methods: {
    showName (idx) {
      this.$bus.clickSound = true

      this.$bus.activeIndex = idx
    }
  },
  watch: {
    '$bus.productsDialog.show': {
      handler (current) {
        if (!current) {
          this.$refs.contentList.scrollTop = 0
        }
      }
    }
  }
}
</script>
<style lang="scss">
.products-content {
  width: 100%;
  height: 100%;

  .products-content-list {
    width: 96%;
    @include px2res(height, 324);
    margin: 0 auto;
    overflow: auto;

    .content-list {
      display: flex;
      flex-wrap: wrap;
      @include px2res(width, 630);
      margin: 0 auto;
    }

    .item {
      @include px2res(width, 90);
      @include px2res(height, 90);
      @include px2res(margin, 18, 18, 0);
    }

    .product-item-name {
      position: absolute;
      top: 30%;
      right: 50%;
      z-index: 99;
      transform: translate(0, -50%);
      @include px2res(padding, 5, 20);
      @include px2res(font-size, 16);
      @include px2res(width, 140);
      letter-spacing: .5px;
      border: 1px solid #deaa44;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
      line-height: 1;
      background-color: #080707;
      text-align: center;
      font-style: italic;
      animation: nameIn .3s ease-out both;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/products/index.vue